// src/mocks/handlers/account/kycConnectedAccountHandler.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';
import {
  IConnectedAccountResponse,
  ICreateConnectedAccountPayload,
} from '@/domains/account/kyc/kyc.types';

export const kycConnectedAccountHandler = rest.post(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.ACCOUNT_CONNECTED_ACCOUNT}`,
  async (req, res, ctx) => {
    const customer_uuid = req.params.customer_uuid as string;

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    let body: ICreateConnectedAccountPayload;
    try {
      body = await req.json();
    } catch {
      return res(ctx.status(400), ctx.json({ error: 'Invalid JSON body' }));
    }

    if (!body.agreed_to_data_usage || !body.agreed_to_terms_and_conditions) {
      return res(
        ctx.status(422),
        ctx.json({ error: 'Required consents not accepted' }),
      );
    }

    let status: IConnectedAccountResponse['status'];
    if (customer_uuid === 'c1') status = 'CREATED';
    else if (customer_uuid === 'c2') status = 'ACTION_REQUIRED';
    else status = 'SUBMITTED'; // fallback

    const response: IConnectedAccountResponse = {
      status,
      fund: 'revving_fund_eu',
      external_id: `ext_${customer_uuid}_${Date.now()}`,
    };

    return res(ctx.status(200), ctx.json(response));
  },
);
